const isFskNotKnown = fsk => undefined === fsk || null === fsk || -1 === fsk

export default isFskNotKnown